import { useRouter } from "@/app/hooks/useRouter";
import CartHeaderComponent from "../../CartBillingComponent/CartHeaderComponent";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { usePaymentUserWalletAPI } from "@/app/hooks/api_hooks/payment/usePaymentUserWalletAPI";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useEffect } from "react";
import NoItemFoundComponent from "@/app/components/ui/NoItemFoundComponent";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import { useLoader } from "@/app/hooks/useLoader";
import { useNavigate } from "react-router";
import { usePaymentWalletTransactionAPI } from "@/app/hooks/api_hooks/payment/usePaymentWalletTransactionAPI";
import { useUtils } from "@/app/hooks/useUtils";
import { ICartState } from "@/app_redux/reducers/slices/auth/cart_slice";
import RBACFlag from "@/app/components/core/RBACFlag";
import { useAdvanceCollectionEligibilityAPI } from "@/app/hooks/api_hooks/payment/useAdvanceCollectionEligibilityAPI";
import { useAppSelector } from "@/app_redux/hooks/root_hook";

const CreditListComponent = () => {
  const { getRouteKey } = useRouter();
  const { veticDateFormat, InvoiceStatusDataTransformed } = useUtils();
  const { NO_CART } = useImageConstants();
  const navigate = useNavigate();
  const isWalletLoading = useLoader("isCustomerWalletTableInProgress");
  const { walletDetails } = useRouteInfo(getRouteKey("CART_MANAGEMENT", "id")).routeState.state as ICartState;
  const { customerId } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id")).routeState.state as ICustomerProfileState;
  const { execute: fetchUserWalletDetails } = usePaymentUserWalletAPI();
  const { execute: fetchWallettransaction, walletTransaction } = usePaymentWalletTransactionAPI();
  const { execute: fetchAdvanceCollectionEligibility, isEligible: isAdvanceCollectionEligible } =
    useAdvanceCollectionEligibilityAPI();
  const mappedClinicId = useAppSelector((state) => state?.root?.UIStates?.mappedClinicId);

  //CALL API
  useEffect(() => {
    if (customerId) {
      fetchUserWalletDetails(customerId);
      fetchWallettransaction(customerId);
    }
  }, [customerId]);

  useEffect(() => {
    if (customerId && mappedClinicId) {
      fetchAdvanceCollectionEligibility(mappedClinicId, customerId, "wallet");
    }
  }, [customerId, mappedClinicId]);

  const handelClick = () => {
    navigate(`/app/user-cart/add-credit/${customerId}?from_cart=true`);
  };

  return (
    <>
      <div className="  h-full ">
        <div className="pb-0.5 rounded-lg bg-white pl-2 pr-2">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center border-b pb-2 gap-2">
            <p className="text-sm font-semibold mt-2">Wallet Transactions</p>
            {isAdvanceCollectionEligible === true && (
              <RBACFlag actionId="ADD_CREDIT_ACTION_BUTTON">
                <button
                  className="bg-[var(--color-primary)] text-xs px-4 sm:px-6 py-1.5 sm:py-2 rounded-lg text-white font-medium border-none w-full sm:w-auto mt-2"
                  onClick={() => handelClick()}
                >
                  Add Credit
                </button>
              </RBACFlag>
            )}
          </div>
          <CartHeaderComponent />
        </div>
        <div>
          {isWalletLoading ? (
            <TableSkeleton />
          ) : walletTransaction?.length > 0 ? (
            <div className="mt-2 scroll-inner !h-auto max-h-[520px] sm:max-h-[650px] flow-root relative rounded-xl bg-[#F9FAFB] overflow-auto">
              <div className="w-full">
                <div className="inline-block min-w-full align-middle">
                  <table className="w-full min-w-[980px] border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]">
                    <thead className="bg-[#F5F5F5] text-[#1F1F23] font-normal sticky top-0 z-20">
                      <tr>
                        {tableHeader.map((key, index) => (
                          <th
                            key={index}
                            scope="col"
                            className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black tracking-wider"
                          >
                            {key.item}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {walletTransaction?.map((cl, index) => {
                        const isFirst = index === 0;
                        const isLast = index === walletTransaction.length - 1;
                        const isSingle = walletTransaction.length === 1;

                        return (
                          <tr
                            key={index}
                            className={`
                          bg-white
                          ${isSingle ? "rounded-xl" : ""}
                          ${isFirst && !isSingle ? "rounded-t-xl" : ""}
                          ${isLast && !isSingle ? "rounded-b-xl" : ""}
                        `}
                          >
                            <td
                              className={`
                            whitespace-nowrap px-2 py-3 text-xs text-black
                            ${isSingle ? "rounded-tl-2xl rounded-bl-2xl" : ""}
                            ${isFirst && !isSingle ? "rounded-tl-2xl" : ""}
                            ${isLast && !isSingle ? "rounded-bl-2xl" : ""}
                          `}
                            >
                              {cl?.transaction_id}
                            </td>
                            <td className="whitespace-nowrap px-2 py-3 text-xs text-black capitalize">
                              {InvoiceStatusDataTransformed(cl?.wallet_type)}
                            </td>
                            <td className="whitespace-nowrap px-2 py-3 text-xs text-black">{cl?.transaction_type}</td>
                            <td className="whitespace-nowrap px-2 py-3 text-xs text-black">
                              {cl?.created_at ? veticDateFormat(cl?.created_at) : "NA"}
                            </td>
                            <td className="whitespace-nowrap px-2 py-3 text-xs text-black">{cl?.amount}</td>
                            <td className="whitespace-nowrap px-2 py-3 text-xs text-black">{cl?.payment_mode}</td>
                            <td className="whitespace-nowrap px-2 py-3 text-xs text-black">{cl?.clinic_name}</td>
                            <td
                              className={`
                            px-2 py-3 text-xs text-black max-w-[220px] sm:max-w-[340px] whitespace-normal break-words
                            ${isSingle ? "rounded-tr-2xl rounded-br-2xl" : ""}
                            ${isFirst && !isSingle ? "rounded-tr-2xl" : ""}
                            ${isLast && !isSingle ? "rounded-br-2xl" : ""}
                          `}
                            >
                              {cl?.comments || "NA"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            walletTransaction?.length === 0 && (
              <div className="bg-white h-[400px] mt-3">
                <NoItemFoundComponent
                  message=""
                  description="No Wallet Transaction Found"
                  imageURL={NO_CART}
                  InputClassName="my-0 h-full"
                />
              </div>
            )
          )}
        </div>
      </div>
    </>
  );
};

export default CreditListComponent;

const TableSkeleton = () => {
  return (
    <div className="mt-3 scroll-inner !h-auto max-h-[520px] sm:max-h-[650px] flow-root relative rounded-xl bg-[#F9FAFB] overflow-auto animate-pulse">
      <div className="w-full">
        <div className="inline-block min-w-full align-middle">
          <table className="w-full min-w-[980px] border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]">
            <thead className="bg-[#F5F5F5] text-[#1F1F23] font-normal sticky top-0 z-20">
              <tr>
                {[...Array(8)].map((_, index) => (
                  <th key={index} className="p-2 py-3 text-left text-xs font-medium text-gray-300 tracking-wider">
                    <div className="h-3 bg-gray-200 rounded w-3/4"></div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...Array(8)].map((_, rowIndex) => (
                <tr key={rowIndex} className="bg-white">
                  {[...Array(7)].map((_, colIndex) => (
                    <td key={colIndex} className="px-2 py-3 whitespace-nowrap text-xs text-gray-300">
                      <div className="h-3 bg-gray-200 rounded w-full"></div>
                    </td>
                  ))}
                  <td className="px-2 py-3 text-xs text-gray-300 max-w-[220px] sm:max-w-[340px] whitespace-normal">
                    <div className="h-3 bg-gray-200 rounded w-full"></div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const tableHeader = [
  { item: "Transaction Id" },
  { item: "Wallet Type" },
  { item: "Transaction Type" },
  { item: "Date & Time" },
  { item: "Amount" },
  { item: "Payment Mode" },
  { item: "Clinic" },
  { item: "Comment" },
];
